import React from "react";
import SelfOnboarding from "./SelfOnboarding";
import { selfOnboardingApi } from "../../../api/user";
import { setFlashNotification } from "../../../redux/modules/flashNotification";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Choice } from "./type";
type Props = {
    choices: Array<Choice>,
};

const SelfOnboardingContainer = ({ choices }: Props) => {
    const [loading, setLoading] = React.useState(false);
    const userId = useSelector(
        (state) => state?.questionnaireData?.initialMetadata?.user_id
    );
    const dispatch = useDispatch();
    const navigate = useNavigate();
     const [searchParams] = useSearchParams();
    
    const onSubmit = async (_data: any) => {
        const selfUserId = userId || localStorage.getItem("self-user-id");
        const ageRange = localStorage.getItem("age_range");

        setLoading(true);

        try {
            const data = {
                ..._data,
                user_type: ["CLIENT"],
                user_id: selfUserId,
                age_range: ageRange,
            };

            // Self onboarding API
            await selfOnboardingApi(data,searchParams);
            setLoading(false);

            dispatch(
                setFlashNotification({
                    message: "Invitation sent",
                })
            );

            dispatch(
                setFlashNotification({
                    message:
                        "Important!  You need to finish verifying your email to reserve your appointment time.  The appointment time cannot be guaranteed until registration is completed.",
                    duration: 14000,
                })
            );
            localStorage.setItem("self-email", _data?.email);
            // Navigate to show display message page
            navigate(
                "/verify-onboarding",
               { state: {
                    email: _data?.email,
                }},
            );
          

        } catch (err) {
            setLoading(false);
            const message =
                err.response.data.message || "Failed to invite user";

            dispatch(
                setFlashNotification({
                    message,
                    isError: true,
                    duration: 9000,
                })
            );
        }
    };

    return (
        <SelfOnboarding
            choices={choices}
            onSubmit={onSubmit}
            loading={loading}
        />
    );
};

export default SelfOnboardingContainer;
